"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _ShareInput = _interopRequireDefault(require("../decorators/ShareInput"));

var _UIAbstractNumberInput = _interopRequireDefault(require("./abstract/UIAbstractNumberInput"));

var _UITextInput = _interopRequireDefault(require("./UITextInput"));

var BLANK_REGEX = /^\s*$/;

var getCurrencySymbol = function getCurrencySymbol(currency, isNativeCurrency) {
  var symbolData = _I18n.default.currencySymbols[currency];
  if (!symbolData) return '';
  return (isNativeCurrency ? symbolData.symbol_native : symbolData.symbol) || '';
};

var getCurrencyPrecision = function getCurrencyPrecision(currency) {
  var symbolData = _I18n.default.currencySymbols[currency];
  return symbolData ? symbolData.decimal_digits : 2;
};

var getCurrencyFormatter = function getCurrencyFormatter(currency, isNativeCurrency) {
  return function (value) {
    if (value == null) return '';
    var currencyOptions = {
      unit: getCurrencySymbol(currency, isNativeCurrency),
      precision: getCurrencyPrecision(currency)
    };
    return _I18n.default.formatCurrency(value, currencyOptions);
  };
};

var getCurrencyParser = function getCurrencyParser(currency, isNativeCurrency) {
  return function (rawString) {
    var currencySymbol = getCurrencySymbol(currency, isNativeCurrency);
    var currencySymbolRegex = new RegExp("" + currencySymbol.replace(/\W/g, '\\$&'), 'g');
    var valueToParse = rawString.replace(currencySymbolRegex, '');
    return BLANK_REGEX.test(valueToParse) ? null : _I18n.default.parseNumber(valueToParse);
  };
};

var UICurrencyInput =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UICurrencyInput, _PureComponent);

  function UICurrencyInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UICurrencyInput);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UICurrencyInput).call(this, props));
    _this._getCurrencyFormatter = (0, _memoizeOne.default)(getCurrencyFormatter);
    _this._getCurrencyParser = (0, _memoizeOne.default)(getCurrencyParser);
    return _this;
  }

  (0, _createClass2.default)(UICurrencyInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          currency = _this$props.currency,
          formatter = _this$props.formatter,
          isNativeCurrency = _this$props.isNativeCurrency,
          parser = _this$props.parser,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["currency", "formatter", "isNativeCurrency", "parser"]);
      return _react.default.createElement(_UIAbstractNumberInput.default, (0, _extends2.default)({}, rest, {
        formatter: formatter || currency && this._getCurrencyFormatter(currency, isNativeCurrency),
        parser: parser || currency && this._getCurrencyParser(currency, isNativeCurrency)
      }), function (numberProps) {
        return _react.default.createElement(_UITextInput.default, (0, _extends2.default)({}, numberProps, {
          type: "text"
          /* Other `type` prop values are ignored; see #4178 */

        }));
      });
    }
  }]);
  return UICurrencyInput;
}(_react.PureComponent);

UICurrencyInput.propTypes = (0, _extends2.default)({}, (0, _omit.default)(_UITextInput.default.propTypes, ['type']), (0, _omit.default)(_UIAbstractNumberInput.default.propTypes, ['children', 'currency', 'formatStyle']), {
  currency: _propTypes.default.oneOf(Object.keys(_I18n.default.currencySymbols)).isRequired,
  isNativeCurrency: _propTypes.default.bool.isRequired
});
UICurrencyInput.defaultProps = (0, _extends2.default)({}, _UITextInput.default.defaultProps, _UIAbstractNumberInput.default.defaultProps, {
  isNativeCurrency: true
});
UICurrencyInput.displayName = 'UICurrencyInput';

var _default = (0, _ShareInput.default)((0, _Controllable.default)(UICurrencyInput));

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/input/UICurrencyInput.js
// module id = 702
// module chunks = 5 6